"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "eraclea": {
    "9708371e": [{
      "hkey": "ebc769cd",
      "slug": "eraclea",
      "name": "Eraclea",
      "primary": true,
      "skipSearch": false
    }],
    "largon": [{
      "hkey": "ebc769cd",
      "slug": "eraclea",
      "name": "Eraclea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0a1ec19f": [{
      "hkey": "2a8ab9ed",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "paluda": [{
      "hkey": "2a8ab9ed",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "eraclea"
    }],
    "979e7a2b": [{
      "hkey": "ebc769cd",
      "slug": "eraclea",
      "name": "Eraclea",
      "primary": true,
      "skipSearch": false
    }],
    "tortoletto": [{
      "hkey": "ebc769cd",
      "slug": "eraclea",
      "name": "Eraclea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;